export default "__VITE_ASSET__B3yJ_3ca__"